import { render, staticRenderFns } from "./TicketRequestDeleteCustomer.vue?vue&type=template&id=26d2cbb3&scoped=true&"
import script from "./TicketRequestDeleteCustomer.vue?vue&type=script&lang=ts&"
export * from "./TicketRequestDeleteCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./TicketRequestDeleteCustomer.vue?vue&type=style&index=0&id=26d2cbb3&lang=sass&scoped=true&"
import style1 from "./TicketRequestDeleteCustomer.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d2cbb3",
  null
  
)

export default component.exports